<!--
This file is part of the project: "Digiziege"
An app for animal-welfare-oriented goat husbandry and contactless weight estimation.
GitLab: https://gitlab.rlp.net/proj-wise2526-digiziege/digiziege

Copyright (c) 2026 Digiziege Team TH-Bingen

Description:
Companion app for welfare-oriented goat husbandry featuring contactless weight estimation via camera,
master data management and health tracking.
Built as a PWA with a local-first approach to ensure data privacy.

LICENSE INFORMATION:
This program is free software: you can redistribute it and/or modify it under the terms of the
GNU Affero General Public License as published by the Free Software Foundation,
either version 3 of the License, or (at your option) any later version.

This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
See the GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License along with this program.
If not, see <https://www.gnu.org/licenses/>.
-->

<template>
  <div
    class="min-h-screen bg-[var(--color-bg)] text-[var(--color-text)] flex flex-col">
    <div class="flex-1 flex flex-col gap-5 container-padding pb-24 py-4">
      <div
        class="bg-[var(--color-primary-200)] p-6 rounded-2xl shadow-md border border-[var(--color-primary-400)]">
        <div>
          <pre style="white-space: pre-wrap; word-wrap: break-word;">{{ textContent }}</pre></div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import legalNoticeDE from '@/assets/LegalNoticeDE.txt?raw';
  import legalNoticeEN from '@/assets/LegalNoticeEN.txt?raw';
  import { onMounted, ref, watch } from 'vue' 
  import { useI18n } from 'vue-i18n'
  import { useUiStore } from '@/stores/ui.store.js' 

  const { t, locale } = useI18n()
  const uiStore = useUiStore()

  const textContent = ref('')
  
  onMounted(() => {
    uiStore.setHeader({
      title: t('views.more.legalNotice.title'), 
      showBack: true,
      showAdd: false
    })

    textContent.value = locale.value === 'en'
    ? legalNoticeEN
    : legalNoticeDE
})

</script>
